(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-view-modal-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    // Move all quick-view modals to <body> so they escape any CSS transform
    // containing blocks created by ancestor elements (e.g. data-reveal animations).
    // This must run before wiring event listeners.
    document.querySelectorAll('[data-quickview-modal]').forEach((modal) => {
      document.body.appendChild(modal);
    });

    const openButtons = Array.from(document.querySelectorAll('[data-quickview-open]'));
    if (!openButtons.length) return;

    const closeModal = (modal) => {
      modal.hidden = true;
      document.body.classList.remove('quick-view-open');
    };

    const syncVariant = (modal) => {
      const select = modal.querySelector('[data-quickview-variant-select]');
      if (!select) return;

      const variants = Array.from(select.options).map((option) => ({
        id: option.value,
        price: option.dataset.price || '',
        compare: option.dataset.compare || '',
        available: option.dataset.available === 'true',
        mediaId: option.dataset.mediaId || '',
        sku: option.dataset.sku || '',
        options: [option.dataset.option1 || '', option.dataset.option2 || '', option.dataset.option3 || ''],
      }));

      const getSelectedValues = () => [1, 2, 3].map((position) => {
        const checked = modal.querySelector(`fieldset[data-option-position="${position}"] input:checked`);
        return checked ? checked.value : '';
      });

      const setSelectedValues = (values) => {
        values.forEach((value, index) => {
          if (!value) return;
          const input = modal.querySelector(`fieldset[data-option-position="${index + 1}"] input[value="${CSS.escape(value)}"]`);
          if (input && !input.disabled) input.checked = true;
        });
      };

      const updateAvailability = (selectedValues) => {
        [1, 2, 3].forEach((position) => {
          const fieldset = modal.querySelector(`fieldset[data-option-position="${position}"]`);
          if (!fieldset) return;
          const inputs = Array.from(fieldset.querySelectorAll('input'));
          inputs.forEach((input) => {
            const nextValues = [...selectedValues];
            nextValues[position - 1] = input.value;
            const hasAvailableVariant = variants.some((variant) => variant.available && variant.options.every((variantValue, index) => !nextValues[index] || variantValue === nextValues[index]));
            input.disabled = !hasAvailableVariant;
            input.nextElementSibling?.classList.toggle('is-disabled', !hasAvailableVariant);
          });
        });
      };

      let selectedValues = getSelectedValues();
      updateAvailability(selectedValues);

      let matched = variants.find((variant) => variant.options.every((value, index) => !selectedValues[index] || value === selectedValues[index]));
      if (!matched) {
        matched = variants.find((variant) => variant.available && variant.options.every((value, index) => !selectedValues[index] || value === selectedValues[index])) || variants.find((variant) => variant.available) || variants[0];
        if (matched) {
          setSelectedValues(matched.options);
          selectedValues = matched.options;
          updateAvailability(selectedValues);
        }
      }

      if (!matched) return;

      select.value = matched.id;
      const price = modal.querySelector('[data-quickview-price]');
      const compare = modal.querySelector('[data-quickview-compare]');
      const sku = modal.querySelector('[data-quickview-sku]');
      const submit = modal.querySelector('[data-quickview-submit]');
      if (price) price.textContent = matched.price || price.textContent;
      if (compare) {
        if (matched.compare) {
          compare.hidden = false;
          compare.textContent = matched.compare;
        } else {
          compare.hidden = true;
          compare.textContent = '';
        }
      }
      if (sku) sku.textContent = matched.sku || sku.textContent;
      if (submit) {
        const available = matched.available;
        submit.disabled = !available;
        submit.textContent = available ? (submit.dataset.labelAdd || submit.textContent) : (submit.dataset.labelSold || submit.textContent);
      }

      if (matched.mediaId) {
        const matchingThumb = modal.querySelector(`[data-quickview-thumb][data-media-id="${matched.mediaId}"]`);
        if (matchingThumb) matchingThumb.click();
      }

      if (modal.__qvSyncPlanPrices) modal.__qvSyncPlanPrices();
    };

    const setupQvPlans = (modal) => {
      const po = modal.querySelector('[data-qv-purchase-options]');
      const dataEl = modal.querySelector('[data-qv-plan-allocations]');
      const spInput = modal.querySelector('[data-qv-selling-plan-input]');
      if (!po || !dataEl) return;
      let planData = { allocations: [], groupPlans: {} };
      try { planData = JSON.parse(dataEl.textContent); } catch (e) {}
      const select = modal.querySelector('[data-quickview-variant-select]');

      const setActivePlan = (radio) => {
        const type = radio.dataset.planType;
        const groupId = radio.dataset.groupId || '';
        po.querySelectorAll('[data-qv-plan-frequency]').forEach((el) => { el.hidden = true; });
        if (type === 'otp' || !groupId) {
          if (spInput) { spInput.value = ''; spInput.disabled = true; }
        } else {
          const freqEl = po.querySelector('[data-qv-plan-frequency="' + groupId + '"]');
          if (freqEl) freqEl.hidden = false;
          if (spInput) {
            const sel = freqEl ? freqEl.querySelector('[data-qv-plan-freq-select]') : null;
            const single = freqEl ? freqEl.querySelector('[data-qv-plan-freq-single]') : null;
            const planId = sel ? sel.value : (single ? single.value : '');
            spInput.value = planId; spInput.disabled = !planId;
          }
        }
      };

      const syncPlanPrices = () => {
        const variantId = select ? String(select.value) : null;
        if (!variantId) return;
        const allocs = planData.allocations.filter((x) => String(x.variantId) === variantId);
        const otpEl = po.querySelector('[data-qv-otp-price]');
        const priceEl = modal.querySelector('[data-quickview-price]');
        if (otpEl && priceEl) otpEl.textContent = priceEl.textContent;
        Object.entries(planData.groupPlans || {}).forEach((entry) => {
          const groupId = entry[0]; const planIds = entry[1];
          const alloc = allocs.find((x) => planIds.map(String).includes(String(x.planId)));
          if (!alloc) return;
          const sp = po.querySelector('[data-qv-sub-price="' + groupId + '"]');
          const wp = po.querySelector('[data-qv-was-price="' + groupId + '"]');
          if (sp) sp.textContent = alloc.priceMoney;
          if (wp) wp.textContent = alloc.compareMoney;
        });
        const checked = po.querySelector('[data-qv-plan-radio]:checked');
        if (checked) setActivePlan(checked);
      };

      po.querySelectorAll('[data-qv-plan-radio]').forEach((r) => r.addEventListener('change', () => setActivePlan(r)));
      po.querySelectorAll('[data-qv-plan-freq-select]').forEach((s) => s.addEventListener('change', () => {
        if (spInput) { spInput.value = s.value; spInput.disabled = !s.value; }
      }));

      modal.__qvSyncPlanPrices = syncPlanPrices;
      const init = po.querySelector('[data-qv-plan-radio]:checked');
      if (init) setActivePlan(init);
      syncPlanPrices();
    };

    const wireModal = (modal) => {
      modal.querySelectorAll('[data-quickview-close]').forEach((closeBtn) => {
        closeBtn.addEventListener('click', () => closeModal(modal));
      });

      modal.querySelectorAll('[data-quickview-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.imageSrc;
          const main = modal.querySelector('.quick-view__main-image');
          if (main && src) {
            main.srcset = '';
            main.src = src;
          }
          modal.querySelectorAll('[data-quickview-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      modal.querySelectorAll('fieldset input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => syncVariant(modal));
      });

      modal.querySelectorAll('[data-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const input = modal.querySelector('[data-qty-input]');
          if (!input) return;
          const current = Number(input.value) || 1;
          const next = button.dataset.qtyStep === 'up' ? current + 1 : Math.max(1, current - 1);
          input.value = String(next);
        });
      });

      setupQvPlans(modal);
      syncVariant(modal);
    };

    const modals = Array.from(document.querySelectorAll('[data-quickview-modal]'));
    modals.forEach(wireModal);

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.quickviewOpen;
        const modal = document.querySelector(`[data-quickview-modal="${target}"]`);
        if (!modal) return;
        modal.hidden = false;
        const dialog = modal.querySelector('.quick-view__dialog');
        if (dialog) dialog.scrollTop = 0;
        document.body.classList.add('quick-view-open');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openModal = document.querySelector('[data-quickview-modal]:not([hidden])');
      if (openModal) closeModal(openModal);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const initMotion = () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealGroups = Array.from(document.querySelectorAll('[data-reveal-group]'));

      revealGroups.forEach((group) => {
        const children = Array.from(group.children);
        children.forEach((child, index) => {
          if (!child.hasAttribute('data-reveal')) child.setAttribute('data-reveal', '');
          if (!child.style.getPropertyValue('--reveal-delay')) {
            child.style.setProperty('--reveal-delay', `${index * 80}ms`);
          }
        });
      });

      const revealTargets = Array.from(document.querySelectorAll('[data-reveal]'));

      if (!revealTargets.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
        return;
      }

      document.body.classList.add('motion-ready');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.16,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      revealTargets.forEach((target) => {
        const top = target.getBoundingClientRect().top;
        if (top < window.innerHeight * 0.88) {
          target.classList.add('is-visible');
        } else {
          observer.observe(target);
        }
      });

      const floating = Array.from(document.querySelectorAll('[data-float]'));
      if (!floating.length) return;

      let ticking = false;
      const updateFloat = () => {
        floating.forEach((item) => {
          const rect = item.getBoundingClientRect();
          const midpoint = window.innerHeight * 0.5;
          const distance = (rect.top + rect.height * 0.5 - midpoint) * -0.025;
          item.style.transform = `translate3d(0, ${Math.max(-10, Math.min(10, distance))}px, 0)`;
        });
        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateFloat);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateFloat();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMotion, { once: true });
    } else {
      initMotion();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
